import { PremissasService } from 'src/app/services/premissas.service';
import { Component, OnInit, Inject } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { TransportadoraService } from 'src/app/services/transportadora.service';
import { Transportadora } from 'src/app/models/transportadora';
import { IbgeService } from 'src/app/services/ibge.service';
import { Ibge } from 'src/app/models/ibge';
import { MASKS } from 'ng-brazil';
import { ViaCepService } from 'src/app/services/via-cep.service';
import { ViaCep } from 'src/app/models/viacep';
import { Modalidade } from 'src/app/models/modalidade';
import { PremissasSistema } from 'src/app/models/premissas-sistema';
import { ConsultaCnpjService } from "../../../core/services/consulta-cnpj.service";
import { FontesConsultaCnpjModel } from "../../../dominio/fontes-consulta-cnpj-model";

declare const $: any;

@Component({
  selector: "app-cadastrar-transportadora-modal",
  templateUrl: "./cadastrar-transportadora-modal.component.html",
  styleUrls: ["./cadastrar-transportadora-modal.component.scss"],
})
export class CadastrarTransportadoraModalComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};
  public MASKS = MASKS;
  idTransportadora: string;
  transportadora: Transportadora;
  cidades = [];
  cidadeSelecionada = undefined;
  estadoSelecionado = undefined;
  tiposDeStatus = [
    { id: 0, nome: "Bloqueado" },
    { id: 1, nome: "Ativo" },
  ];
  statusSelecionado = 1;
  tiposDeStatusModalidade = [
    { id: -1, nome: "Todos" },
    { id: 1, nome: "Ativo" },
    { id: 0, nome: "Bloqueado" },
  ];
  statusModalidadeSelecionado = 1;
  carregando = false;
  estados = [
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MT",
    "MS",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO",
  ];

  modalidades: Modalidade[] = [];
  novaMod: Modalidade = new Modalidade();
  criarModalidade: boolean = false;
  grupos: string[] = [];
  grupoSelecionado: string;
  editandoMod = null;

  premissasSistema: PremissasSistema;
  usaModalidade: boolean = false;
  fontesConsultaCnpj: FontesConsultaCnpjModel[] = [];

  constructor(
    private transportadoraService: TransportadoraService,
    public utilitarioService: UtilitarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    public dialogRef: MatDialogRef<CadastrarTransportadoraModalComponent>,
    private ibgeService: IbgeService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private viaCepService: ViaCepService,
    private premissasService: PremissasService,
    private consultaCnpjService: ConsultaCnpjService
  ) {}

  async ngOnInit() {
    this.idTransportadora = this.data.idTransportadora;

    await this.buscarPremissasSistema();
    this.buscarFontesConsultaCnpj();

    if (!this.idTransportadora) {
      this.transportadora = new Transportadora();
    } else {
      this.buscarTransportadora();
    }
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra("buscarPremissasSistema");
      this.premissasSistema = await this.premissasService
        .consultarPremissasSistema()
        .toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde("buscarPremissasSistema");
    }
  }

  buscarCidades(nomeCidade?: string) {
    this.carregandoService.mostra("buscaCidades");
    this.ibgeService.consultarPorEstado(this.estadoSelecionado).subscribe(
      (ibges: Ibge[]) => {
        this.cidades = ibges;

        if (nomeCidade) {
          this.cidadeSelecionada = this.cidades.find(
            (s) =>
              this.utilitarioService.remover_acentos_espaco(
                s.cidade.toLowerCase().trim()
              ) ===
              this.utilitarioService.remover_acentos_espaco(
                nomeCidade.toLowerCase().trim()
              )
          )
            ? this.cidades.find(
                (s) =>
                  this.utilitarioService.remover_acentos_espaco(
                    s.cidade.toLowerCase().trim()
                  ) ===
                  this.utilitarioService.remover_acentos_espaco(
                    nomeCidade.toLowerCase().trim()
                  )
              ).cod
            : undefined;
        } else {
          this.cidadeSelecionada = this.cidades.find(
            (s) => s.cod === this.transportadora.ibge
          )
            ? this.cidades.find((s) => s.cod === this.transportadora.ibge).cod
            : "";
        }

        this.carregandoService.esconde("buscaCidades");
      },
      (erro) => {
        this.carregandoService.esconde("buscaCidades");
      }
    );
  }

  atualizaDadosTransportadora() {
    if (this.transportadora.uf) {
      this.estadoSelecionado = this.estados.find(
        (s) => s === this.transportadora.uf
      );
    }

    if (this.transportadora.ativo) {
      this.statusSelecionado = this.tiposDeStatus.find(
        (s) => s.id === this.transportadora.ativo
      )
        ? this.tiposDeStatus.find((s) => s.id === this.transportadora.ativo).id
        : 1;
    }

    this.rodaScriptTabEnter();

    this.buscarCidades();

    this.carregandoService.esconde("buscarTransportadora");
    this.carregando = false;
  }

  rodaScriptTabEnter() {
    this.utilitarioService.rodaScriptTabEnter();
  }

  focalizaNumero() {
    $("#numero").focus();
  }

  verificaCep() {
    if (!this.transportadora.cep.includes("_")) this.buscarEnderecoPorCep();
  }

  atualizarCep() {
    window.open("https://viacep.com.br/cep/", "_blank");

    // const largura = Number(($('body').width()));

    // const dialogRef = this.dialog.open(AtualizaCepModalComponent, {
    //   width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
    //   data: {},
    //   panelClass: 'modal-card'
    // });

    // dialogRef.afterClosed().subscribe((result: any) => {

    // });
  }

  buscarEnderecoPorCep() {
    this.carregandoService.mostra("buscaEnderecoPorCep");
    this.viaCepService.obterEndereco(this.transportadora.cep).subscribe(
      (viaCep: ViaCep) => {
        this.transportadora.bairro = viaCep.bairro;
        this.transportadora.rua = viaCep.logradouro;
        this.estadoSelecionado = viaCep.uf;
        this.transportadora.ibge = viaCep.ibge;
        this.cidadeSelecionada = viaCep.ibge;

        this.buscarCidades();

        this.focalizaNumero();

        this.carregandoService.esconde("buscaEnderecoPorCep");
      },
      (erro) => {
        this.transportadora.bairro = "";
        this.transportadora.rua = "";
        this.estadoSelecionado = undefined;
        this.transportadora.ibge = "";
        this.cidadeSelecionada = undefined;
        this.carregandoService.esconde("buscaEnderecoPorCep");
        this.notificacaoService.erro(
          "Não foi possível acessar o serviço de CEP ou CEP Inválido!"
        );
      }
    );
  }

  consultarCnpj(idFonte: string | null = null) {
    this.carregandoService.mostra("consultarCnpj");

    this.consultaCnpjService
      .consultar(this.transportadora.cnpj, idFonte)
      .subscribe(
        (data) => {
          const resultado = data.result;

          let telefone: string | null = null;

          if (resultado.telefones && resultado.telefones.length > 0) {
            telefone = resultado.telefones[0];
          }

          let email: string | null = null;

          if (resultado.emails && resultado.emails.length > 0) {
            email = resultado.emails[0];
          }

          this.transportadora.cnpj = resultado.cnpj;
          this.transportadora.nome = resultado.razaoSocial;
          this.transportadora.fantasia = resultado.nomeFantasia ? resultado.nomeFantasia : resultado.razaoSocial;
          //this.transportadora.dtAbert = dataAbertura;

          this.transportadora.rua = resultado.logradouro;
          this.transportadora.n = resultado.numero != null ? resultado.numero : this.transportadora.n;
          this.transportadora.compl = resultado.complemento != null ? resultado.complemento : this.transportadora.compl;
          this.transportadora.bairro = resultado.bairro;
          this.transportadora.ibge = undefined;
          this.estadoSelecionado = resultado.uf;
          this.transportadora.cep = resultado.cep;

          this.buscarCidades(resultado.cidade);

          this.transportadora.tel1 = telefone != null ? telefone : this.transportadora.tel1;
          this.transportadora.email = email != null ? email : this.transportadora.email;

          this.carregandoService.esconde("consultarCnpj");
      },
      (erro) => {
        this.carregandoService.esconde("consultarCnpj");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarTransportadora() {
    this.carregandoService.mostra("buscarTransportadora");

    this.transportadoraService.consultarPorId(this.idTransportadora).subscribe(
      (transportadora) => {
        this.transportadora = transportadora;

        this.atualizaDadosTransportadora();
      },
      (erro) => {
        this.carregandoService.esconde("buscarTransportadora");
        this.notificacaoService.erro(erro);
      }
    );
  }

  salvar() {
    this.carregandoService.mostra("salvaTransportadora");
    this.transportadora.uf = this.estadoSelecionado;
    this.transportadora.id = this.idTransportadora;
    this.transportadora.ativo = this.statusSelecionado;
    this.transportadora.ibge = this.cidadeSelecionada;
    this.transportadora.cidade = this.cidades.find(
      (s) => s.cod === this.transportadora.ibge
    )
      ? this.cidades.find((s) => s.cod === this.transportadora.ibge).cidade
      : "";

    this.transportadoraService.salvar(this.transportadora).subscribe(
      () => {
        this.carregandoService.esconde("salvaTransportadora");
        this.notificacaoService.sucesso("Transporadora salva com sucesso!!!");
        this.dialogRef.close(true);
      },
      (erro) => {
        this.carregandoService.esconde("salvaTransportadora");
        this.notificacaoService.erro(erro);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }

  buscarFontesConsultaCnpj() {
    this.carregandoService.mostra("buscarFontesConsultaCnpj");

    this.consultaCnpjService.buscarFontes().subscribe(
      (data) => {
        this.fontesConsultaCnpj = data.results;
        this.carregandoService.esconde("buscarFontesConsultaCnpj");
      },
      (erro) => {
        this.carregandoService.esconde("buscarFontesConsultaCnpj");
        this.notificacaoService.erro(erro);
      }
    );
  }
}
